import React, { Component } from "react";
import "../../assets/web/assets/mobirise-icons2/mobirise2.css";
import "../../assets/web/assets/mobirise-icons/mobirise-icons.css";
import "../../assets/tether/tether.min.css";
import "../../assets/bootstrap/css/bootstrap.min.css";
import "../../assets/bootstrap/css/bootstrap-grid.min.css";
import "../../assets/bootstrap/css/bootstrap-reboot.min.css";
import "../../assets/dropdown/css/style.css";
import "../../assets/socicon/css/styles.css";
import "../../assets/theme/css/style.css";
import "../../assets/mobirise/css/mbr-additional.css";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import Header from "./navigation/Header";
import Footer from "./navigation/Footer";
import { GetBusinessProfile } from "../../store/actions/profileActions";
import { signOut } from "../../store/actions/authActions";
import { GetADHistory, GetController } from "../../store/actions/adcardActions";
import BusinessADHistoryComponent from "./BusinessADHistoryComponent";
import Loading from "../widgets/Loading";
import { numberWithCommas } from "../../functions/utils";

class BusinessDashboardPage extends Component {
  state = {
    routescovered: 0,
    peoplereached: 0,
  };

  componentDidMount() {
    document.title = "Loading...";

    if (
      this.props.profile.profile !== null &&
      this.props.profile.region !== null
    ) {
      this.props.getAdHistory();
      this.props.getController();
    }
  }

  componentDidUpdate(prev, curr) {
    if (this.props.profile.profile === null) {
      if (
        prev.firebase.profile.isLoaded === false &&
        this.props.firebase.profile.isLoaded === true &&
        prev.firebase.profile.isEmpty &&
        !this.props.firebase.profile.isLoaded
      ) {
        this.props.getBusiness();
      }
    } else if (
      this.props.profile.profile !== prev.profile.profile &&
      this.props.profile.profile !== null
    ) {
      this.props.getAdHistory();
    } else if (
      this.props.profile.region !== prev.profile.region &&
      this.props.profile.region !== null
    ) {
      this.props.getController();
    } else if (
      this.props.adcard.adcardloading === false &&
      this.props.adcard.adcards !== prev.adcard.adcards
    ) {
      var temproutescovered = 0;
      var temppeoplereached = 0;
      this.props.adcard.adcards.forEach((add) => {
        temproutescovered += add.totalNumberOfAdsServed;
        temppeoplereached += add.totalServedAmount;
      });
      this.setState({
        routescovered: temproutescovered,
        peoplereached: temppeoplereached,
      });
      document.title = "Dashboard";
    }
  }

  render() {
    if (this.props.auth.uid && !this.props.auth.isAnonymous) {
      if (this.props.profile == null) {
        this.props.signOut();
      } else if (
        !this.props.adcard.adcardloading &&
        !this.props.adcard.controllerloading &&
        this.props.adcard.controller !== null
      ) {
        return (
          <div>
            <Header active="Dashboard" />
            <section className="info2 cid-smIC4FePEy" id="info2-b">
              <div className="align-center container-fluid">
                <div className="row justify-content-center">
                  <div className="card col-12 col-lg-4">
                    <div className="wrapper">
                      <h3 className="mbr-section-title mb-4 mbr-fonts-style display-7">
                        <strong>Current Balance</strong>
                      </h3>
                      <p className="mbr-text mb-4 mbr-fonts-style display-2">
                        {this.props.profile.profile &&
                        this.props.profile.profile.balance !== undefined &&
                        this.props.profile.profile.balance !== null
                          ? numberWithCommas(
                              this.props.profile.profile.balance.toFixed(2)
                            ) + " ETB"
                          : "-"}
                      </p>
                    </div>
                  </div>
                  <div className="card col-12 col-lg-4">
                    <div className="wrapper">
                      <h3 className="mbr-section-title mb-4 mbr-fonts-style display-7">
                        <strong>Total Number of Routes Covered</strong>
                      </h3>
                      <p className="mbr-text mb-4 mbr-fonts-style display-2">
                        {numberWithCommas(this.state.routescovered)}
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-lg-4">
                    <div className="wrapper">
                      <h3 className="mbr-section-title mbr-fonts-style mb-4 display-7">
                        <strong>People Reached (Approx.)</strong>
                      </h3>
                      <p className="mbr-text mbr-fonts-style mb-4 display-2">
                        {numberWithCommas(this.state.peoplereached)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="content4 cid-ssRdZ7QAUw" id="content4-18">
              <div className="container-fluid">
                <div className="row justify-content-center">
                  <div className="title col-10">
                    <h3 className="mbr-section-title mbr-fonts-style align-left mb-4 display-2">
                      <span id="active_ads_text">
                        <strong>Your Advertisements</strong>
                        {this.props.adcard.adcards &&
                          this.props.adcard.adcards.length > 0 &&
                          "(" + this.props.adcard.adcards.length + ")"}
                        <br />
                        <a
                          className="btn btn-primary-outline display-4"
                          href="https://www.youtube.com/watch?v=EH-8FKlsDTs"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <u>Watch a video to learn how to manage</u>
                        </a>
                      </span>
                      <span id="active_ads_buy_air_time_btn_span">
                        <a
                          className="btn btn-success display-2"
                          href="/business_buy_airtime"
                        >
                          Buy Airtime
                        </a>
                      </span>
                    </h3>
                  </div>
                </div>
              </div>
            </section>
            <section className="content1 cid-ssS8bQ0Wof" id="content1-1l">
              <div className="container-fluid">
                {this.props.adcard.adcards.length === 0 ? (
                  <div className="row justify-content-center">
                    <h3 className="mbr-section-title mbr-fonts-style mb-4 display-2">
                      <span id="active_ads_text">
                        You haven't purchased any Advertisements
                      </span>
                    </h3>
                  </div>
                ) : (
                  <div className="row">
                    {this.props.adcard.adcards.map(function (item) {
                      return (
                        <BusinessADHistoryComponent key={item.id} data={item} />
                      );
                    })}
                  </div>
                )}
              </div>
            </section>

            <Footer />
          </div>
        );
      } else {
        return (
          <div className="row justify-content-center fullloading">
            <div className="col-lg-8 form-group">
              <Loading />
            </div>
          </div>
        );
      }
    }
    return <Redirect to="/" />;
  }
}
const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.profile,
    firebase: state.firebase,
    adcard: state.adcard,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getBusiness: () => dispatch(GetBusinessProfile()),
    getAdHistory: () => dispatch(GetADHistory()),
    getController: () => dispatch(GetController()),
    signOut: () => dispatch(signOut()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BusinessDashboardPage);
